const routes = [
  {
    path: '/question-answer-details',
    name: 'question-answer-details',
    component: () =>
      import('@/views/question-answer/QuestionAnswerDetails.vue'),
    meta: {
      title: '问答详情',
      hideShare: true,
    },
  },
  {
    path: '/answer-details',
    name: 'answer-details',
    component: () => import('@/views/question-answer/AnswerDetails.vue'),
    meta: {
      title: '回答详情',
      hideShare: true,
    },
  },
  {
    path: '/expert-info',
    name: 'expert-info',
    component: () => import('@/views/question-answer/ExpertInfo.vue'),
    meta: {
      title: '专家主页',
      hideShare: true,
    },
  },
  {
    path: '/expert-list',
    name: 'expert-list',
    component: () => import('@/views/question-answer/ExpertListPage.vue'),
    meta: {
      title: '科普中国专家', // 专家列表
    },
  },
];
export default routes;
